var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-box",class:{ flat: _vm.flat, [`type-${_vm.type}`]: _vm.type }},[_c('div',{staticClass:"inner d-flex"},[_c('div',{staticClass:"pr-3"},[_c('v-icon',[_vm._v(_vm._s(_vm.icons[_vm.type]))])],1),_c('div',{staticClass:"flex-grow-1"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }